import React from 'react';
import './criteres.css'
import CritereTablePage from "./critereTablePage";

function Criteres(props) {
    return (
        <CritereTablePage/>
    );
}

export default Criteres;